//--------------- API PÚBLICA DA LASTLINK (credenciais + ofertas) ---------------//
import api from "../../../shared/services/api";

const lastlinkConfigService = {
  obter:       () => api.get("/integracoes/lastlink-config"),
  salvar:      (payload) => api.put("/integracoes/lastlink-config", payload),
  testar:      () => api.post("/integracoes/lastlink-config/testar"),
  sincronizar: () => api.post("/integracoes/lastlink-config/sincronizar"),
  ofertas:     () => api.get("/integracoes/lastlink-config/ofertas"),
  vincular:    (ofertaId, produtoId) => api.put(`/integracoes/lastlink-config/ofertas/${ofertaId}/produto`, { produto_id: produtoId }),
};

export default lastlinkConfigService;
